module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-state-indicator"
  }, _vm._l((_vm.customerStates), function(detailedStates, topState) {
    return _c('span', {
      staticClass: "customer-state label",
      class: _vm.getLabelClass(topState)
    }, [(!_vm.mini) ? _c('span', {
      staticClass: "parent-state-label"
    }, [_vm._v(_vm._s(topState))]) : _vm._e(), _vm._v(" "), _vm._l((detailedStates), function(detailedState) {
      return _c('span', {
        staticClass: "child-state badge",
        class: _vm.getBadgeClass(detailedState),
        attrs: {
          "title": _vm.getTip(topState, detailedState)
        },
        domProps: {
          "innerHTML": _vm._s(_vm.getStateText(detailedState))
        }
      })
    })], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3d301f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/blocks/client/CustomerStateIndicator.vue
// module id = 1111
// module chunks = 0